import { Injectable } from '@angular/core';
import { Adapter } from '../interfaces/adapter.interface';
import { HelperService } from '../services/shared/helper/helper.service';

export class Device {
  constructor(
    public deviceId: string = '',
    public deviceGroup: number = 0,
    public deviceType: number = 0,
    public sensorProfile: number = 0,
    public associated_env: string = '',
    public hwRevision: string = '',
    public fwRevision: string = '',
    public startOfService: Date = new Date(),
    public endOfLifecycle: Date = new Date(),
    public endOfLicense: Date = new Date(),
    public statusId: number = 0,
    public coldStoreId?: number,
    public coldStoreName?: string,
    public customerName?: string,
    public coldStore?: ColdStore
  ){}
}
export class ColdStore {
  constructor(
    public id: number,
    public name: string,
    public coordinates: string,
    public profile_id: number,
    public customer_id: number,
    public profile_type_id: number,
    public commodity_id: number,
    public cs_status: number,
    public device_id: string,
    public customer_name: string
  ){}
}
@Injectable({
    providedIn: 'root'
})

export class DeviceAdapter implements Adapter<Device> {

  constructor(private _helper: HelperService){}

  adapt(item: any): Device {
    return new Device(
      item.device_id,
      item.device_group,
      item.device_type,
      item.sensor_profile,
      item.associated_env,
      item.hw_rev,
      item.fw_rev,
      (item.start_of_service) ? new Date(item.start_of_service) : null,
      (item.end_of_life_cycle) ? new Date(item.end_of_life_cycle) : null,
      (item.end_of_license) ? new Date(item.end_of_license) : null,
      item.status_id,
      item.cold_store?item.cold_store.id: null,
      item.cold_store?item.cold_store.name: null,
      item.cold_store?item.cold_store.customer_name: null,
      item.cold_store? new ColdStore(
        item.cold_store.id,
        item.cold_store.name,
        item.cold_store.coordinates,
        item.cold_store.profile_id,
        item.cold_store.customer_id,
        item.cold_store.profile_type_id,
        item.cold_store.commodity_id,
        item.cold_store.cs_status,
        item.cold_store.device_id,
        item.cold_store.customer_name
      ) : null
    );
  }

  reverseAdapt(item: Device): any {
    return {
      created_by: this._helper.user.get()['id'],
      modified_by: this._helper.user.get()['id'],
      device_group: item.deviceGroup,
      device_type: item.deviceType,
      end_of_license: (item.endOfLicense) ? item.endOfLicense.getTime() : item.endOfLicense,
      end_of_life_cycle: (item.endOfLifecycle) ? item.endOfLifecycle.getTime(): item.endOfLifecycle,
      fw_rev: item.fwRevision,
      hw_rev: item.hwRevision,
      device_id: item.deviceId,
      sensor_profile: item.sensorProfile,
      start_of_service: (item.startOfService) ? item.startOfService.getTime() : item.startOfService,
      status_id: item.statusId,
    }
  }

}